'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactFela = require('react-fela');

var View = function View(props) {
  return {
    display: props.hidden ? 'none' : 'flex',
    zIndex: props.zIndex,
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
};

exports.default = (0, _reactFela.createComponent)(View);
module.exports = exports['default'];